import * as Sentry from '@sentry/react'
import SentryFullStory from '@sentry/fullstory'
import { BrowserTracing } from '@sentry/tracing'
import routerHistory from '../../utils/routing/history'

import store from '../../store/configureStore'
import application from '../constants/application'

const environment = process.env.REACT_APP_ENVIRONMENT
const sampleRate = process.env.REACT_APP_SENTRY_SAMPLE_RATE

const configure = () => {
  if (application.isProduction) {
    Sentry.init({
      attachStacktrace: true,
      dsn: process.env.REACT_APP_SENTRY_PUBLIC_DSN,
      environment,
      integrations: [
        new SentryFullStory('steppingblocks'),
        new BrowserTracing({
          routingInstrumentation: Sentry.reactRouterV4Instrumentation(routerHistory),
          tracingOrigins: [
            process.env.REACT_APP_API_HOST_GRAPHQL,
            `${process.env.REACT_APP_API_HOST_GRAPHQL}/*`,
            process.env.REACT_APP_API_HOST,
            `${process.env.REACT_APP_API_HOST}/*`,
          ],
        }),
      ],
      normalizeDepth: 10,
      tracesSampler: samplingContext => {
        if (samplingContext.parentSampled !== undefined) {
          return samplingContext.parentSampled
        }
        return sampleRate
      },
    })

    const {
      currentUser: { user },
    } = store.getState()
    Sentry.setUser(user)
  }
}

const report = (error, reducer) => {
  if (application.isProduction) {
    const {
      currentUser: { user },
    } = store.getState()

    Sentry.configureScope(scope => {
      if (user) {
        scope.setUser({
          name: user.profile.name,
          email: user.email,
          id: user._id,
          insToken: user.insToken,
          isSystemAdministrator: user.isSystemAdministrator,
        })
        scope.setTag('user', user)
      }
    })

    if (error.type) {
      Sentry.withScope(scope => {
        scope.setTag('type', error.type)
        Sentry.captureException(error, {
          extra: {
            ...store.getState()[reducer],
          },
        })
      })
    } else {
      Sentry.captureException(error, {
        extra: {
          ...store.getState()[reducer],
        },
      })
    }
  }
}

export default {
  configure,
  report,
}



// WEBPACK FOOTER //
// ./src/utils/analytics/error.js